// extracted by mini-css-extract-plugin
export default {"filter":"styles_filter__cLv0c","label":"styles_label__oWhEQ","statusSelect":"styles_statusSelect__lpc9s","placeholder":"styles_placeholder__lMZiI","footer":"styles_footer__ZB6WQ"};